import axios from "axios";

//live
//export const baseUrl = "http://192.168.20.38:6002/api";
//export const baseUrlAncillary = "http://192.168.1.6:6002/ancillary";
//export const baseMonitorUrl = "http://192.168.1.23:7080/api";
//export const baseUrlTraining = "http://192.168.20.38:6005/trainings";
//export const cardPaymentApi = "http://192.168.1.224:5006/api"

// Domain
//export const baseUrl = "http://192.168.20.38:6002/api";
//export const baseUrlAncillary = "http://192.168.1.6:6002/ancillary";
//export const baseMonitorUrl = "http://192.168.1.23:7080/api";
//export const baseUrlTraining = "http://192.168.20.38:6005/trainings";
//export const cardPaymentApi = "http://192.168.1.224:5006/api"

// Rangoonwala LIVE
 export const baseUrl = "https://hims.hrintellect.co.in/api";
 export const baseMonitorUrl = "http://192.168.1.37:7080/api";
 export const baseUrlAncillary = "http://192.168.1.37:5003/ancillary";
 export const baseUrlTraining = "http://192.168.1.37:5003/trainings";
 export const cardPaymentApi = "http://192.168.1.37:5006/api";

//Live IP
//inamdar  premises testing
// export const baseUrl = "http://172.16.6.179:5003/api";
// export const baseUrlAncillary = "http://172.16.6.179:5003/ancillary";
// export const baseMonitorUrl = "http://172.16.6.179:7080/api";
// export const baseUrlTraining = "http://172.16.6.179:6005/trainings";
// export const cardPaymentApi = "http://172.16.6.179:5006/api"

//224
// export const baseUrl = "http://10.190.32.117:5003/api";
// export const baseUrlAncillary = "http://10.190.32.117:5003/ancillary";
// export const baseMonitorUrl = "http://192.168.1.23:7080/api";
// export const baseUrlTraining = "http://192.168.1.12:6005/trainings";
// export const cardPaymentApi = "http://10.190.32.117:5006/api";

// Local
// export const baseUrl = "http://192.168.102:5003/api";
// export const baseMonitorUrl = "http://192.168.102:7080/api";
// export const baseUrlAncillary = "http://192.168.102:5003/ancillary";
// export const baseUrlTraining = "http://192.168.102:5003/trainings";
// export const cardPaymentApi = "http://192.168.102:5006/api";

// appy stack server
// export const baseUrl = "http://192.168.0.193:5003/api";
// export const baseMonitorUrl = "http://192.168.0.193:7080/api";
// export const baseUrlAncillary = "http://192.168.0.193:5003/ancillary";
// export const baseUrlTraining = "http://192.168.0.114:6002/api/trainings";

export default axios.create({
  baseURL: baseUrl,
  headers: {
    "Content-Type": "application/json",
    maxBodyLength: Infinity,
    maxContentLength: Infinity,
  },
});

export const monitorVitalsApi = axios.create({
  baseURL: baseMonitorUrl,
});

export const cssdApiClients = axios.create({
  baseURL: baseUrlAncillary,
});
export const paymentApiClient = axios.create({
  baseURL: cardPaymentApi,
});

export const printersApi = axios.create({
  baseURL: "http://localhost:6004/api",
  // baseURL: "http://192.168.0.230:6004/api",
  // headers: {
  //   "Content-type": "application/json",
  // },
});
export const trainingApiClient = axios.create({
  baseURL: baseUrlTraining,
});
